import { Dropdown } from 'antd';
import type { DropdownProps } from 'antd';

/**
 * Trình đơn thả xuống (§9.3.14). Truyền `menu={{ items }}`.
 * ❌ Không tự dựng bằng `useState` + `div` định vị tuyệt đối.
 */
export function DropdownMenu({ trigger = ['click'], ...props }: DropdownProps) {
  return <Dropdown trigger={trigger} {...props} />;
}
